<template>
<div id="topnav">
<van-nav-bar
  class="topnav"

  :title="title"
  left-arrow
  @click-left="onClickLeft"
/>
</div>

</template>

<script>
import {NavBar} from 'vant';

export default {
   components: {
    [NavBar.name]: NavBar,
  },
  data() {
    return {
      // title:"临时缴费"
    }
  },
  props: ["title"],
   methods: {
    onClickLeft() {

      let url = this.$route.path;
      if(url.indexOf("success") > 0 || url.indexOf("paydetail") > 0){
        let backPage = sessionStorage.getItem("backPage");
        if (!this.commonUtil.isEmpty(backPage)){
          this.$router.push('/'+backPage);
          return;
        }
        this.$router.push('/index');
      }
      // alert(url)
      if(url.indexOf("nofeel") > 0){
        this.$router.push('/index');
      }
      else{
        this.$router.go(-1)
      }

    }
  }
}

</script>

<style>
#topnav .van-nav-bar
  {
    background-color:rgb(248,248,248);
  }
  #topnav .van-nav-bar .van-icon{
    color:black;
  }
</style>



// WEBPACK FOOTER //
// src/components/topnav/topnav.vue